import * as ss from 'superstruct';
import { ObjectSchema, ObjectType } from 'superstruct/dist/utils';
import { SortOrder } from './sort-order.type';

export type SortParams<T> = [keyof T & string, SortOrder];

export const sortParamSchema = <T extends ObjectType<ObjectSchema>>(
  struct: ss.Struct<T, ObjectSchema>,
) => {
  const validFields = Object.keys(struct.schema);
  return ss.tuple([ss.enums(validFields), SortOrder]);
};

export const isValidSortParam = <T extends ObjectType<ObjectSchema>>(
  sortParam: unknown,
  struct: ss.Struct<T, ObjectSchema>,
): sortParam is SortParams<T> => {
  const sortStruct = sortParamSchema(struct);
  return ss.is(sortParam, sortStruct);
};
